// extracted by mini-css-extract-plugin
export var noMarginBottom = "richText-module--noMarginBottom--e1983";
export var wrapper = "richText-module--wrapper--76d6a";